<template>
    <div>
      <p class="admin-title">{{$t('form.user.user')}}: {{user | fullName}}</p>

      <div class="a-tab" id="accordion-tab">
        <div class="a-tab__control">
          <router-link to="account" tag="button" type="button" class="a-tab__btn" active-class="a-active " >{{$t('account.personal-data')}}</router-link>
          <router-link v-if="organization" to="contractor" tag="button" type="button" class="a-tab__btn" active-class="a-active">{{$t('account.contractor')}}</router-link>
          <router-link v-if="!user.permissions.USER_CANNOT_CREATE_ACCREDITATION" to="accreditation" tag="button" type="button" class="a-tab__btn" active-class="a-active">{{$t('account.accreditation')}}</router-link>
          <router-link v-if="!user.permissions.USER_CANNOT_CREATE_ACCREDITATION" to="accreditation-history" tag="button" type="button" class="a-tab__btn" active-class="a-active">{{$t('account.accreditation-history')}}</router-link>
          <router-link v-if="user.permissions.USER_CANNOT_CREATE_ACCREDITATION" to="signatures" tag="button" type="button" class="a-tab__btn" active-class="a-active">{{$t('account.digital-signature')}}</router-link>
        </div>

        <div class="collapse" :class="showPersonalData && 'show'" id="collapse-tab1" data-parent="#accordion-tab" data-target="#collapse-tab1" aria-labelledby="heading-tab1" aria-expanded="true">
          <div class="admin__container-title">
            <h2>{{$t('account.personal-data')}}</h2>
          </div>
          <form class="human-data">
            <personal-data-view-mode :profile="profile"></personal-data-view-mode>
          </form>
        </div>
        <div class="collapse" v-if="organization" :class="showContractor && 'show'" id="collapse-tab2" data-parent="#accordion-tab" data-target="#collapse-tab1" aria-labelledby="heading-tab1" aria-expanded="true">
          <div class="admin__container-title">
            <h2>{{$t('account.contractor')}}</h2>
          </div>
          <form class="human-data">
            <contractor-view-mode :profile="profile" :organization="organization" ></contractor-view-mode>
          </form>
        </div>
        <div class="collapse" v-if="!user.permissions.USER_CANNOT_CREATE_ACCREDITATION" :class="showAccreditation && 'show'" id="collapse-tab3" data-parent="#accordion-tab" data-target="#collapse-tab1" aria-labelledby="heading-tab1" aria-expanded="true">
          <div class="admin__container-title">
            <h2>{{$t('account.accreditation')}}</h2>
          </div>
          <form class="human-data">
            <accreditation-view-mode :profile="profile" :accreditation="accreditation" ></accreditation-view-mode>
          </form>
        </div>
        <div class="collapse" v-if="!user.permissions.USER_CANNOT_CREATE_ACCREDITATION" :class="showAccreditationHistory && 'show'" aria-expanded="true">
          <div class="admin__container-title">
            <h2>{{$t('account.accreditation-history')}}</h2>
          </div>
          <form class="human-data">
            <accreditation-history :profile="profile" ></accreditation-history>
          </form>
        </div>
        <div class="collapse" v-if="user.permissions.USER_CANNOT_CREATE_ACCREDITATION" :class="showSignatures && 'show'" id="collapse-tab4" data-parent="#accordion-tab" data-target="#collapse-tab1" aria-labelledby="heading-tab1" aria-expanded="true">
          <div class="admin__container-title">
            <h2>{{$t('account.digital-signature')}}</h2>
          </div>
          <form class="human-data">
            <signatures-list :profile="profile" :signatures="signatures" ></signatures-list>
          </form>
        </div>
      </div>
    </div>
</template>

<script>
  import PersonalDataViewMode from './PersonalDataViewMode'
  import ContractorViewMode from './ContractorViewMode'
  import AccreditationViewMode from './AccreditationViewMode'
  import SignaturesList from './SignatureList'
  import AccreditationHistory from './AccreditationHistory'

  export default {
    name: "UserDetails",

    components: {
      PersonalDataViewMode, ContractorViewMode, AccreditationViewMode, SignaturesList, AccreditationHistory
    },

    props: {
      profile: Object,
      organization: Object,
      accreditation: Object,
      signatures: Array
    },

    computed: {
      showPersonalData() {
        return this.$route.params.tab === 'account'
      },

      showContractor() {
        return this.$route.params.tab === 'contractor'
      },

      showAccreditation() {
        return this.$route.params.tab === 'accreditation'
      },

      showAccreditationHistory() {
        return this.$route.params.tab === 'accreditation-history'
      },

      showSignatures() {
        return this.$route.params.tab === 'signatures'
      },

      user() {
        return this.profile;
      }
    }
  }
</script>

<style>
</style>
